import httpClient from '@/services/httpClient'
import {AxiosResponse} from 'axios'
import {
  AxiosResponseBoosterInterface,
  MinerInventoryInterface,
  MiscInventoryInterface,
  ResourceInterface,
  StoreAdvisorInterface,
  StoreBoosterInterface,
} from '@/types/types'

const InventoriesService = {
  getResource: (): Promise<
    AxiosResponse<{
      inventories: ResourceInterface[]
      boosters: AxiosResponseBoosterInterface[]
      miners?: MinerInventoryInterface[]
      misc?: MiscInventoryInterface[]
    }>
  > => httpClient.get('/collect/inventories'),
  getStore: (): Promise<
    AxiosResponse<{
      boosters: StoreBoosterInterface[]
      advisors: StoreAdvisorInterface[]
      others: []
    }>
  > => httpClient.get('/store'),
  buyItemStore: (
    id: number,
    counter: number
  ): Promise<AxiosResponse<{status: true}>> =>
    httpClient.post('/store', {id, counter}),
}

export default InventoriesService
